
import styled from "styled-components/macro";
import { AttributeValue } from "../../../hooks/api/queries/useAttributes";
import { useFiltersContext } from "../../../hooks/context/useFiltersContext";
import { breakpoint } from "../../../styles/constants";
import WxCheckbox from "../../checkbox";
import WxRadioColor from "../../radioColor";

import { WxSelect, WxText } from "../..";
import { WImage } from "../image/Image";

interface Props {
  attribute: AttributeValue;
  device?: "mobile" | "desktop";
}

export const AttributeFilter = ({ attribute, device = "mobile" }: Props) => {
  const { attributes, toggleAttribute } = useFiltersContext();
  const selected =
    attributes.find((attr) => attr.id === attribute.id) !== undefined;

  const onSelect = () => toggleAttribute(attribute);
  const key = `attr-value-${attribute.id}`;

  const attributeLabel =
    attribute.label ?? attribute.identifier ?? attribute.code;
  return attribute.image.path ? (
    <Flex>
      <WxRadioColor
        label={attributeLabel}
        onSelect={onSelect}
        selected={selected}
        key={key}
      >
        <WImage image={attribute.image} />
      </WxRadioColor>
      {device === "desktop" && (
        <Clickable onClick={onSelect}>
          <WxText text={attributeLabel} />
        </Clickable>
      )}
    </Flex>
  ) : device === "mobile" ? (
    <WxSelect
      key={key}
      label={attributeLabel}
      selected={selected}
      onSelect={onSelect}
    />
  ) : (
    <WxCheckbox
      label={attributeLabel}
      onSelect={onSelect}
      selected={selected}
    />
  );
};

const Flex = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: ${breakpoint}) {
    margin-bottom: 0.3125rem;
  }
`;

const Clickable = styled.div`
  cursor: pointer;
`;
